/**
 * Deterministic seedable pseudo-random number generator (mulberry32).
 *
 * Given the same seed, the returned function yields the same sequence of
 * values in the half-open range [0, 1). This determinism is what lets the
 * session assembler produce reproducible practice sets.
 */
export function mulberry32(seed: number): () => number {
  let a = seed;
  return function next(): number {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
